import { RiStopCircleLine } from '@remixicon/react';

import { Text } from '@backstage/ui';

import styles from './UserInterruptMessage.module.css';

export const UserInterruptMessage = () => (
  <div className={styles.root}>
    <RiStopCircleLine size={14} className={styles.icon} />
    <Text variant="body-small" color="secondary">
      Response interrupted by the user
    </Text>
  </div>
);
